import { Fragment } from "react";
import makeStyles from "styles/muiStylesCompat/makeStyles";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

const useStyles = makeStyles((_theme) => ({
  textFieldRoot: {
    marginBottom: "12px",
  },
  inputStyles: {
    paddingTop: "10.5px",
    paddingBottom: "10.5px",
  },
  multiText: {
    paddingTop: "0px !important",
  },
  label: {
    transform: "translate(14px, 12px) scale(1)",
  },
}));

const MyTextField = (props) => {
  const {
    customLabel,
    inputProps: inputPropsProp = {},
    InputProps: InputPropsProp = {},
    InputLabelProps: InputLabelPropsProp,
    slotProps: slotPropsProp = {},
    ...rest
  } = props;
  const classes = useStyles();

  const htmlInput = {
    ...inputPropsProp,
    ...(slotPropsProp.htmlInput || {}),
    className: [
      classes.inputStyles,
      inputPropsProp.className,
      slotPropsProp.htmlInput?.className,
    ]
      .filter(Boolean)
      .join(" "),
  };

  const inputSlot = {
    ...InputPropsProp,
    ...(slotPropsProp.input || {}),
    classes: {
      multiline: classes.multiText,
      ...InputPropsProp?.classes,
      ...slotPropsProp.input?.classes,
    },
  };

  const slotProps = {
    ...slotPropsProp,
    htmlInput,
    input: inputSlot,
    inputLabel: {
      shrink: true,
      ...(InputLabelPropsProp || {}),
      ...(slotPropsProp.inputLabel || {}),
    },
  };

  return (
    <Fragment>
      {customLabel ? (
        <Typography variant="subtitle1">
          {customLabel == " " ? <span>&nbsp;</span> : customLabel}
        </Typography>
      ) : null}

      <TextField
        className={classes.textFieldRoot}
        fullWidth
        variant="outlined"
        slotProps={slotProps}
        {...rest}
      />
    </Fragment>
  );
};

export default MyTextField;
